import { render, staticRenderFns } from "./nanjing-old.vue?vue&type=template&id=45fe1454&scoped=true"
import script from "./nanjing-old.vue?vue&type=script&lang=js"
export * from "./nanjing-old.vue?vue&type=script&lang=js"
import style0 from "./nanjing-old.vue?vue&type=style&index=0&id=45fe1454&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45fe1454",
  null
  
)

export default component.exports